import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from "styled-components";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    var isDark = useTheme().isDark;
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 18 18"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    x1: "83.8040865%",
                    y1: "50%",
                    x2: "-1.11022302e-14%",
                    y2: "50%",
                    id: "linearGradient-1",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#50D0B7",
                            offset: "0%"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#00C3FF",
                            offset: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                id: "页面-1",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ _jsx("g", {
                    id: "连接钱包",
                    transform: "translate(-1172.000000, -475.000000)",
                    fill: "url(#linearGradient-1)",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ _jsx("g", {
                        id: "编组-6",
                        transform: "translate(700.000000, 357.000000)",
                        children: /*#__PURE__*/ _jsx("g", {
                            id: "Metamask",
                            transform: "translate(18.000000, 88.000000)",
                            children: /*#__PURE__*/ _jsx("g", {
                                id: "编组-5",
                                transform: "translate(12.000000, 15.000000)",
                                children: /*#__PURE__*/ _jsx("path", {
                                    fill: isDark ? "" : "#002237",
                                    d: "M451,15 C451.248527,15 451.460329,15.087624 451.636475,15.2625563 C451.812039,15.437513 451.900367,15.6501649 451.900367,15.9001238 L451.900367,23.0986626 L459.099391,23.0986626 C459.3485,23.0986626 459.560424,23.1886653 459.735745,23.3636219 C459.912522,23.5387242 460,23.7512548 460,23.9987864 C460,24.2487452 459.912376,24.4587515 459.735745,24.6363538 C459.560545,24.8113105 459.3485,24.8989102 459.099391,24.8989102 L451.900367,24.8989102 L451.900367,32.0998519 C451.900367,32.3499322 451.812039,32.5599384 451.636475,32.734895 C451.460329,32.9124974 451.248527,32.9999757 451,32.9999757 C450.751473,32.9999757 450.539914,32.912376 450.363525,32.7349193 C450.187961,32.5599384 450.099633,32.3499564 450.099633,32.0998519 L450.099633,24.8989102 L442.900609,24.8989102 C442.65184,24.8989102 442.439819,24.8113105 442.26462,24.6363538 C442.087842,24.4587515 442,24.2487452 442,23.9987864 C442,23.7512305 442.087964,23.5387242 442.264498,23.3636219 C442.439698,23.1886653 442.65184,23.0986626 442.900488,23.0986626 L450.099633,23.0986626 L450.099633,15.9000024 C450.099633,15.6499222 450.187961,15.4373916 450.363525,15.262435 C450.539914,15.0874783 450.751473,15 451,15",
                                    id: "swap_icon_+"
                                })
                            })
                        })
                    })
                })
            })
        ]
    }));
};
export default Icon;
